import { takeLatest } from 'redux-saga/effects';
import {
  getBreedingEventListSuccess, getBreedingEventListFail,
  getBreedingEventDetailsSuccess, getBreedingEventDetailsFail
} from './breedingEventState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/breeding-events');
const redirectData = {route:'/console/breeding-events', mode: 'list', recordId:0 };
const modelName = 'Breeding Events';
const modelId = 'id';

function* getBreedingEventList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getBreedingEventListSuccess, 
		getBreedingEventListFail);
}

function* getBreedingEventDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getBreedingEventDetailsSuccess, 
		getBreedingEventDetailsFail);		
}

function* doBreedingEventCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getBreedingEventDetailsSuccess, 
		getBreedingEventDetailsFail,
		`${modelName} record has been created.`,
		redirectData);
}

function* doBreedingEventUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getBreedingEventDetailsSuccess, 
		getBreedingEventDetailsFail,
		`${modelName} record has been updated.`,
		redirectData);	
}

function* doBreedingEventDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getBreedingEventDetailsSuccess, 
		getBreedingEventDetailsFail,
		`${modelName} record has been deleted.`,
		{...redirectData, mode: data.payload.mode});	
}

function* breedingEventSaga() {
  yield takeLatest('breedingEvent/getBreedingEventList', getBreedingEventList);
  yield takeLatest('breedingEvent/getBreedingEventDetails', getBreedingEventDetails);
  yield takeLatest('breedingEvent/doBreedingEventCreate', doBreedingEventCreate);
  yield takeLatest('breedingEvent/doBreedingEventUpdate', doBreedingEventUpdate);
  yield takeLatest('breedingEvent/doBreedingEventDelete', doBreedingEventDelete);  
}

export default breedingEventSaga;
